const shuffle = arr => [...arr].sort(() => Math.random() - Math.random());

export default shuffle;
